import styled from 'styled-components';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const RadiosConteiner = styled.div`
  display: flex;

  width: fit-content;
`;

export const RadioConteiner = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  margin: 5px 5px;
`;

export const RadioLabel = styled.label`
  margin: 0 5px;
`;

export const TextoDeErro = styled.span`
  color: ${(props) => props.theme.DANGER};
`;
